// @flow
export const ArtistName = "the mountain goats";

export const ModalText =
  `Search for a word or a phrase and see all the places the Mountain Goats
has used it in their music! To search for multiple words or phrases, use
a comma between them. Use a * for wildcard search. Scraped data is from
<a href="https://themountaingoats.fandom.com/">the wiki</a> CC-BY-SA
  `;